import { css } from '@emotion/css';

const miniGameIconStyles = {
    wrapIcon: css`
        position: fixed;
        bottom: 24px;
        left: 24px;
        z-index: 10;
        &.active {
            pointer-events: none;
            opacity: 0.4;
        }
    `,
    iconItem: css`
        position: relative;
        width: 120px;
        cursor: pointer;
        img {
            width: 100%;
        }
        .iconItem-txt {
            position: absolute;
            bottom: 4px;
            animation: animation-zssgdl 0.6s ease-in-out infinite;
            left: 0;
        }
    `,
    bgOverlay: css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 11;
        background: rgba(0, 0, 0, 0.6);
        opacity: 0;
        pointer-events: none;
        &.active {
            opacity: 1;
            pointer-events: initial;
        }
    `,
    wrapGameList: css`
        position: fixed;
        z-index: 12;
        left: -100px;
        bottom: -100px;
        transition: 0.4s;
        transform: scale(0.2);
        pointer-events: none;
        opacity: 0;
        &.show {
            left: calc(50% - 180px);
            bottom: calc(50% - 180px);
            transform: scale(1);
            opacity: 1;
            pointer-events: initial;
        }
    `,
    gameInnerList: css`
        width: 300px;
        height: 300px;
        background: rgba(255, 255, 255, 0.8);
        padding: 12px;
        border-radius: 16px;
        position: relative;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        .game-item {
            position: absolute;
            img {
                cursor: pointer;
                width: 90px;
                filter: drop-shadow(0 0 4px #000);
                &:hover {
                    animation: zoomInOut 0.3s infinite linear;
                }
            }
            &:nth-child(1) {
                left: 50%;
                top: 12px;
                transform: translateX(-50%);
            }
            &:nth-child(2) {
                right: 12px;
                top: 50%;
                transform: translateY(-60%);
            }
            &:nth-child(3) {
                bottom: 12px;
                left: 50%;
                transform: translateX(-50%);
            }
            &:nth-child(4) {
                left: 12px;
                top: 50%;
                transform: translateY(-60%);
            }
        }
    `,
    gameItem: css`
        width: 100px;
        display: flex;
        position: absolute;
        opacity: 0.5;

        &.txcb {
            left: 50%;
            transform: translateX(-50%);
        }
        &.xd,
        &.bc {
            top: 50%;
            transform: translateY(-50%);
        }
        &.bc {
            right: 16px;
        }
        &.xs {
            bottom: 16px;
            left: 50%;
            transform: translateX(-50%);
        }
        &.ready {
            opacity: 1;
            cursor: pointer;
        }
    `,
};
export default miniGameIconStyles;
